import React from 'react';
import { DecorativeLine } from '../../ui/BrandingComponents';

interface GalleryHeaderProps {
  title?: string;
  showDecorativeLine?: boolean;
}

const GalleryHeader: React.FC<GalleryHeaderProps> = ({
  title = "All User Generated Content",
  showDecorativeLine = true,
}) => {
  return (
    <>
      <h2
        className="text-center text-gray-600 font-inter mb-0.5 mt-8 text-xl sm:text-2xl md:text-[20px]"
        style={{ marginBottom: "0.5rem", marginTop: "8rem" }}
      >
        {title}
      </h2>
      {showDecorativeLine && <DecorativeLine />}
    </>
  );
};

export default GalleryHeader;
